
import React from "react";
import { Button } from "@/components/ui/button";
import { Users, Clock, Video } from "lucide-react";

export function ConsultationHero() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Book Expert Consultations
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Connect with verified care placement experts for personalized guidance. 
            Book hourly consultations to get expert advice on Fair Deal applications, 
            care assessments, and family support.
          </p>
          
          <div className="flex flex-wrap justify-center gap-8 mb-10">
            <div className="flex items-center gap-2 text-gray-700">
              <Users className="h-5 w-5 text-grandpal-green" />
              <span>Verified Experts</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <Video className="h-5 w-5 text-grandpal-green" />
              <span>Video Consultations</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <Clock className="h-5 w-5 text-grandpal-green" />
              <span>Flexible Scheduling</span>
            </div>
          </div>

          <Button 
            size="lg"
            className="bg-grandpal-green hover:bg-grandpal-green/90 text-white px-8 py-3"
            onClick={() => document.getElementById('experts')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Browse Experts
          </Button>
        </div>
      </div>
    </section>
  );
}
